import {createAction} from "redux-actions";

export const createMessage = createAction("signtasks/CREATE_MESSAGE");
